/**
 * Canonical feed-map fields shown on the firm configuration screen.
 * Mirrors SCALAR_* in personMapper / officeMapper; the client does not import serverless.
 */

export interface FeedMapField {
  key: string;
  label: string;
}

/** Scalar IMappedPerson fields. Collection pointers (practiceAreas, offices) have their own grids. */
export const PROFESSIONAL_FEED_MAP_FIELDS: FeedMapField[] = [
  { key: "name", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "middleInitial", label: "Middle Initial" },
  { key: "honorary", label: "Honorary Title" },
  { key: "suffix", label: "Suffix" },
  { key: "title", label: "Title" },
  { key: "firmEmail", label: "Firm email" },
  { key: "photo", label: "Photo" },
  { key: "bio", label: "Bio" },
  { key: "phoneNumber", label: "Phone number" },
  { key: "webpage", label: "Webpage" },
  { key: "assistantName", label: "Assistant name" },
  { key: "assistantEmail", label: "Assistant email" },
  { key: "barAdmissions", label: "Bar admissions" },
  { key: "education", label: "Education" },
  { key: "birthInformation", label: "Birth information" },
  { key: "isln", label: "ISLN" },
  { key: "yearJoinedFirm", label: "Year joined firm" },
  { key: "publications", label: "Publications" },
  { key: "seminars", label: "Seminars" },
  { key: "significantAccomplishments", label: "Significant accomplishments" },
  { key: "additionalAffiliations", label: "Additional affiliations" },
  { key: "additionalInformation", label: "Additional information" },
  { key: "pastEmploymentPositions", label: "Past employment positions" },
];

export const OFFICE_FEED_MAP_FIELDS: FeedMapField[] = [
  { key: "name", label: "Name" },
  { key: "address", label: "Address" },
  { key: "cityName", label: "City" },
  { key: "countryName", label: "Country" },
  { key: "stateName", label: "State" },
  { key: "zip", label: "Zip" },
  { key: "phoneNumber", label: "Phone number" },
  { key: "personOfficeType", label: "Person office type" },
];

export const PRACTICE_AREA_FEED_MAP_FIELDS: FeedMapField[] = [
  { key: "practiceAreas", label: "Name" },
];
